import React from "react";
import { Globe, Code, Palette, ShoppingCart, TrendingUp, Server } from "lucide-react";
import { Card } from "./ui/card";
import { portfolioData } from "../data/mock";

const Services = () => {
  const { services } = portfolioData;

  const iconMap = {
    Globe: Globe,
    Code: Code,
    Palette: Palette,
    ShoppingCart: ShoppingCart,
    TrendingUp: TrendingUp,
    Server: Server,
  };

  return (
    <section id="services" className="py-20 bg-slate-800/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-cyan-400 to-violet-500 bg-clip-text text-transparent">
              Mes Services
            </span>
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Un accompagnement complet pour tous vos besoins digitaux
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            
            return (
              <Card
                key={service.id}
                className="group bg-slate-800/50 border-slate-700 hover:border-cyan-500/50 transition-all duration-500 hover:shadow-2xl hover:shadow-cyan-500/10 p-6 hover:scale-105"
              >
                <div className="space-y-4">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-gradient-to-r from-cyan-500/20 to-violet-500/20 rounded-xl flex items-center justify-center group-hover:from-cyan-500/30 group-hover:to-violet-500/30 transition-all duration-300">
                    <IconComponent 
                      className="text-cyan-400 group-hover:text-white transition-colors duration-300" 
                      size={28} 
                    />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-white group-hover:text-cyan-400 transition-colors duration-300">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-slate-400 leading-relaxed">
                    {service.description}
                  </p>

                  {/* Hover indicator */}
                  <div className="h-1 bg-gradient-to-r from-cyan-500 to-violet-500 rounded-full scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Additional Info Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-slate-800 to-slate-700 p-8 rounded-2xl border border-slate-600">
            <h3 className="text-2xl font-bold text-white mb-4">
              Un accompagnement personnalisé
            </h3>
            <p className="text-slate-300 mb-6 max-w-3xl mx-auto leading-relaxed">
              Chaque projet est unique. Je prends le temps de comprendre vos besoins spécifiques 
              pour vous proposer des solutions sur-mesure qui correspondent parfaitement à vos objectifs.
            </p>
            
            <div className="grid md:grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-r from-cyan-500 to-violet-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-white font-bold">1</span>
                </div>
                <h4 className="font-semibold text-white mb-2">Analyse</h4>
                <p className="text-slate-400 text-sm">Étude de vos besoins et objectifs</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-r from-violet-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-white font-bold">2</span>
                </div>
                <h4 className="font-semibold text-white mb-2">Création</h4>
                <p className="text-slate-400 text-sm">Développement de votre solution</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-r from-pink-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-white font-bold">3</span>
                </div>
                <h4 className="font-semibold text-white mb-2">Suivi</h4>
                <p className="text-slate-400 text-sm">Accompagnement post-livraison</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;